import { $post } from '@/api/request'

// 获取手机验证码
export function getMobileCode (data = {}) {
  return $post({
    url: '/smsLogin/getMobileCode',
    data
  })
}
// 手机验证码登陆
export function loginWithMobileCode (data = {}) {
  return $post({
    url: '/smsLogin/loginWithMobileCode',
    data
  })
}
// 管理员登录二次验证
export function doubleCheck (data = {}) {
  return $post({
    url: '/smsLogin/doubleCheck',
    data
  })
}